export default {
      id: "icon-facebook-usage",
      viewBox: "0 0 64 64",
      url: "../icon/" + "icons.svg#icon-facebook-usage",
      toString: function () {
        return this.url;
      }
    }